const RGB_REGEX = /rgb\( *(\d+) *\, *(\d+) *\, *(\d+) *\)/gm

function normalizeColorValues(bbCode: string) {
  return bbCode.replace(RGB_REGEX, fullRgbValue => {
    const [_, ...chanelValuesAsDecStr] = Array.from(fullRgbValue.matchAll(RGB_REGEX)!)[0]

    const channelValuesAsHexStr = chanelValuesAsDecStr.map(value => {
      const hexValue = Number(value).toString(16)
      return hexValue.padStart(2, '0')
    })

    const fullHexValue = `#${channelValuesAsHexStr.join('')}`
    return fullHexValue
  })
}

const ESCAPED_LINK_REGEX = /\[[uU][rR][lL]=\'(.+)\'\]/gm
function unescapeLinks(bbCode: string) {
  return bbCode.replace(ESCAPED_LINK_REGEX, '[url=$1]')
}

export function preTransformBBCode(bbCode: string) {
  const pipeline = [normalizeColorValues, unescapeLinks]
  for (const step of pipeline) bbCode = step(bbCode)

  return bbCode
}
